<template>
  <div>
    <!--        省市区地址-->
    <el-form ref="form" :model="form" :rules="rule_data">
      <el-row type="flex">
        <el-form-item
          prop="provinceCode"
          class="form-flex-item"
          :rules="[{
            required: required,
            message: '请输入省份',
            trigger: 'change'
          }]">
          <select-page
            v-model="form.provinceCode"
            class="areaSelect"
            :value="form.provinceCode"
            :request-data="provinceReq"
            placeholder="请选择省"
            option-value="fAreaCode"
            option-name="fAreaName"
            :pagination="false"
            :remote="false"
            valueName="province"
            requestUrl="getProvinceAlipay"
            :disabled="readOnly"
            @getSelect="setProv"></select-page>
        </el-form-item>
        <el-form-item
          prop="cityCode"
          class="form-flex-item"
          :rules="[{
            required: required,
            message: '请输入市级',
            trigger: 'change'
          }]">
          <select-page
            v-model="form.cityCode"
            class="areaSelect"
            :value="form.cityCode"
            :request-data="cityReq"
            placeholder="请选择市"
            option-value="fAreaCode"
            option-name="fAreaName"
            :disabled="readOnly"
            :pagination="false"
            :remote="false"
            valueName="city"
            @getSelect="setCity"
            requestUrl="getCityAlipay"></select-page>
        </el-form-item>
        <el-form-item
          prop="areaCode"
          class="form-flex-item"
          :rules="[{
            required: required,
            message: '请输入区域',
            trigger: 'change'
          }]">
          <select-page
            v-model="form.areaCode"
            class="areaSelect"
            :value="form.areaCode"
            :request-data="areaReq"
            placeholder="请选择区"
            option-value="fAreaCode"
            option-name="fAreaName"
            :disabled="readOnly"
            :pagination="false"
            :remote="false"
            valueName="area"
            @getSelect="setArea"
            requestUrl="getAreaAlipay"></select-page>
        </el-form-item>
        <el-form-item prop="address" class="form-input">
          <el-input v-model="form.address" placeholder="详细地址需超过5个字，详细到门牌号" :disabled="readOnly" @blur="getAddressTxt"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import selectPage from '@/components/selectPage'
export default {
  name: 'Address',
  components: {
    selectPage
  },
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          provinceCode: '',
          cityCode: '',
          areaCode: '',
          address: ''
        }
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    nameValue: {
      type: Object,
      default: function () {
        return {
          province: '',
          city: '',
          area: ''
        }
      }
    }
  },
  data () {
    return {
      form: {
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        address: ''
      },
      txt: '',
      addressTxt: '',
      rule_data: {
        address: [{
          validator: (rule, value, callback) => {
            if (this.required && value === '') {
              callback(new Error('请输入详细地址'))
            } else if (value !== '') {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入5位以上详细地址'))
              }
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      provinceReq: {
        areaLevel: 1
      }, // 银行网点省的请求数据
      cityReq: {},
      areaReq: {},
      nameForm: {
        province: '',
        city: '',
        area: ''
      }
    }
  },
  mounted () {
    this.form = this.value
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.form = val
      },
      deep: true
    },
    form: {
      handler (val, oldVal) {
        this.$emit('getValue', val)
      },
      deep: true
    },
    nameForm: {
      handler (val, oldVal) {
        this.$emit('getNameValue', val)
      },
      deep: true
    },
    'form.provinceCode': {
      handler (val) {
        if (val !== '') {
          this.cityReq = {
            // areaLevel: 2,
            parentCode: val
          }
        } else {
          this.cityReq = {}
        }
      }
    },
    'form.cityCode': {
      handler (val) {
        if (val !== '') {
          this.areaReq = {
            // areaLevel: 3,
            parentCode: val
          }
        } else {
          this.areaReq = {}
        }
      }
    }
  },
  methods: {
    /**
             * 设置省
             */
    setProv (value) {
      if (value) {
        this.form.provinceCode = value.value
        this.nameForm.province = value.name
      }
      this.form.cityCode = ''
      this.nameForm.city = ''
      this.form.areaCode = ''
      this.nameForm.area = ''
      this.form.address = ''
      this.txt = ''
      this.txt += value.name
    },
    /**
             * 设置市
             */
    setCity (value) {
      if (value) {
        this.form.cityCode = value.value
        this.nameForm.city = value.name
      }
      this.form.areaCode = ''
      this.nameForm.area = ''
      this.form.address = ''
      this.txt += value.name
    },
    /**
             * 设置区
             */
    setArea (value) {
      if (value) {
        this.form.areaCode = value.value
        this.nameForm.area = value.name
      }
      this.form.address = ''
      this.txt += value.name
    },
    getAddressTxt () {
      this.addressTxt = this.txt + this.form.address
      this.$emit('getAddressTxt', this.addressTxt)
    }
  }
}
</script>

<style scoped>
    .form-input {
        width: 450px;
    }
    .form-flex-item {
        margin-right: 5px;
    }
</style>
